
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"96","height":"78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M92.41 21.33L40.417 74.34a12.086 12.086 0 01-17.33 0L3.59 54.46c-4.787-4.878-4.787-12.788 0-17.669a12.086 12.086 0 0117.33 0l10.833 11.042L75.08 3.658a12.091 12.091 0 0117.33 0c4.787 4.88 4.787 12.791 0 17.672zM7.74 49.85c-2.209-2.452-2.149-6.264.183-8.643a6.044 6.044 0 018.664 0L31.753 56.67l47.66-48.594a6.039 6.039 0 018.664 0c2.395 2.439 2.395 6.396 0 8.834 0 0-51.186 52.188-51.99 53.01a6.042 6.042 0 01-8.667 0S7.8 49.915 7.74 49.849z","fill":"#A2D100"}})])
          )
        }
      }
    